var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{staticClass:"filter_checkbox",attrs:{"value":_vm.initialValue},on:{"change":function (v) { return _vm.$emit('onChange', v); }}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }